import React from "react";
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { SessionProvider } from './context/SessionContext';
import Layout from './Layout';
import ArtistDashboard from "./pages/ArtistDashboard";
import Cart from "./pages/Cart";
import Home from './pages/Home';
import InstrumentalistInterface from "./pages/InstrumentalistInterface";
import SearchResults from './pages/SearchResults';
import Social from "./pages/Social";
import SongDetails from './pages/SongDetails';
import UserLibrary from './pages/UserLibrary';
import VideoEditorInterface from "./pages/VideoEditorInterface";

const App: React.FC = () => (
	<BrowserRouter>
		<Routes>
			{/* all routes share the same Layout (header/footer/context) and SessionProvider */}
			<Route path="/" element={<SessionProvider><Layout /></SessionProvider>}>
				<Route index element={<Home />} />
				<Route path="search" element={<SearchResults />} />
				<Route path="library" element={<UserLibrary />} />
				<Route path="instrumentalist" element={<InstrumentalistInterface />} />
				<Route path="video-editor" element={<VideoEditorInterface />} />
				<Route path="song-details/:songId" element={<SongDetails />} />
				<Route path="cart" element={<Cart />} />
				<Route path="artists/:artistId/dashboard" element={<ArtistDashboard />} />
				<Route path="videos" element={<Social />} />
				<Route path="*" element={<Home />} />
				{/* Add more routes here */}
			</Route>
		</Routes>
	</BrowserRouter>
);

export default App;
